import { Outlet } from "react-router-dom";
import { Logo } from "@promptgatewaysadmin/ui";
import { config } from "../config.js";

/**
 * Archetype A — a split brand panel plus a 380px form column.
 *
 * The form column is STATIC MARKUP and renders immediately: the Firebase SDK is imported
 * dynamically, so only the Google button waits for it. No auth screen shows a full-page
 * spinner.
 *
 * The trust row reads `GDPR ready · Nothing stored`. The mock also carried an
 * audit-standard badge; it was removed because that audit does not exist. An unverified
 * compliance claim on a signup screen is legal exposure and the first thing an enterprise
 * security reviewer checks — it would put the weakest sentence in the most scrutinised
 * position. "Nothing stored" is the stronger claim anyway: architecturally true, and
 * impossible for a competitor to copy without rebuilding the product.
 *
 * The badge's literal text is deliberately absent from this file, including from this
 * comment: copy-honesty.test.ts greps src/ for it, and a grep cannot tell a claim from a
 * comment about a claim. Allowing comments through would be the loophole that lets it back.
 */
export function AuthLayout() {
  return (
    <div className="pg-auth">
      {/* Not aria-hidden: the brand link inside must stay reachable and announced. */}
      <aside className="pg-auth__brand">
        <a href={config.siteOrigin} aria-label="Prompt Gateway website">
          <Logo />
        </a>
        <p className="pg-auth__tagline">
          Better prompts, everywhere you work.
        </p>
        <ul className="pg-auth__trust">
          <li>GDPR ready</li>
          <li>Nothing stored</li>
        </ul>
      </aside>
      <div className="pg-auth__col">
        <a href="#main" className="pg-skip">
          Skip to main content
        </a>
        <main id="main" tabIndex={-1} className="pg-auth__form">
          <Outlet />
        </main>
        <footer className="pg-auth__footer">
          <a href={`${config.siteOrigin}/legal/terms`} target="_blank" rel="noopener noreferrer">Terms</a>
          <a href={`${config.siteOrigin}/legal/privacy`} target="_blank" rel="noopener noreferrer">Privacy</a>
        </footer>
      </div>
    </div>
  );
}
